import React from "react";
import { Navigate, useParams } from "react-router-dom";
// import { AuthenticatedLayout } from "components/Layouts/AuthenticatedLayout";

import { useStore } from "../utils/helpers";
import { observer } from "mobx-react-lite";

export const PrivateRoute = observer<{ component }>((props) => {
  const rootStore = useStore();
  const { userStore } = rootStore;
  const { isLoggedIn } = userStore;

  const { component: Component } = props;
  // react-router v6 doesn't pass route params as props (unlike @reach/router,
  // which the codebase was migrated from). Many page components still read
  // `props.id` / `props.tab`, so forward the params to preserve that contract.
  const params = useParams();

  return (
    <div>
      {isLoggedIn ? (
        <Component {...params} />
      ) : (
        <Navigate to="/login" replace />
      )}
    </div>
  );
});

export const PublicRoute = observer<any>((props) => {
  const { component: Component } = props;
  const params = useParams();
  return <Component {...params} />;
});
